/** `entity_status` values shared by the X and Pinterest backends. */
export type EntityStatus = 'ACTIVE' | 'PAUSED';

export const ENTITY_STATUS: Record<EntityStatus, EntityStatus> = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
};

/** `ACTIVE` → `Active`; unknown statuses are title-cased so nothing is hidden. */
export const formatEntityStatus = (status: string): string =>
  status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : '—';
